export const ExhibitionPresetId = {
  Automotive: 'automotive',
  Aerospace: 'aerospace',
  Machinery: 'machinery',
  Electronics: 'electronics',
  Food: 'food',
  Plastics: 'plastics',
  Other: 'other',
  Empty: 'empty',
} as const;

export type ExhibitionPresetId = (typeof ExhibitionPresetId)[keyof typeof ExhibitionPresetId];

export const EXHIBITION_PRESET_IDS = Object.values(ExhibitionPresetId);

export interface ExhibitionPresetSuggestionDto {
  suggestedPresetId: ExhibitionPresetId | null;
}

export interface StartExhibitionSessionDto {
  presetId: ExhibitionPresetId;
}

export interface StartExhibitionSessionResponse {
  sessionId: string;
  attachmentIds: string[];
}
